import React from 'react';
import { FaWhatsapp, FaLinkedin, FaInstagram } from 'react-icons/fa';

const COLUMNS = [
  {
    heading: 'For Job Seekers',
    links: [
      { label: 'Search Jobs',      href: '/search' },
      { label: 'Resume Builder',   href: '/login' },
      // { label: 'Government Jobs',  href: '/login' }, // temporarily hidden
      // { label: 'Job Alerts',       href: '/login' }, // temporarily hidden
      { label: 'Career Blog',      href: '/blogs' },
    ],
  },
  {
    heading: 'For Employers',
    links: [
      { label: 'Post a Job Free',      href: 'https://recruiter.jobxbharat.com/', external: true },
      { label: 'Recruiter Dashboard',  href: 'https://recruiter.jobxbharat.com/', external: true },
      { label: 'Hire Blue-Collar',     href: 'https://recruiter.jobxbharat.com/', external: true },
      { label: 'Contract Workforce',   href: 'https://recruiter.jobxbharat.com/', external: true },
    ],
  },
  {
    heading: 'For Colleges',
    links: [
      { label: 'Placement ERP',       href: 'mailto:supportus@jobxbharat.com' },
      { label: 'Book a Demo',         href: 'mailto:supportus@jobxbharat.com' },
      { label: 'Campus Drive Tool',   href: 'mailto:supportus@jobxbharat.com' },
      { label: 'Placement Analytics', href: 'mailto:supportus@jobxbharat.com' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About Us',            href: '/about' },
      { label: 'Blogs',               href: '/blogs' },
      { label: 'Contact Us',          href: '/contact' },
      { label: 'Privacy Policy',      href: '/privacy-policy' },
      { label: 'Terms & Conditions',  href: '/terms-and-conditions' },
    ],
  },
];

const SOCIALS = [
  { icon: <FaWhatsapp />,  href: 'https://wa.me/917002502224',                                                                    label: 'WhatsApp' },
  { icon: <FaLinkedin />,  href: 'https://www.linkedin.com/company/jobxbharat/',                                                  label: 'LinkedIn' },
  { icon: <FaInstagram />, href: 'https://www.instagram.com/jobxbharat?igsh=MXB1aTRieXhydGxrMg%3D%3D&utm_source=qr',             label: 'Instagram' },
];

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-100">

      {/* Main grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-10 md:pt-16 pb-8 md:pb-10
                      grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-10">

        {/* Brand column */}
        <div className="col-span-2 md:col-span-3 lg:col-span-1">
          <div className="font-brand font-black text-2xl tracking-tight text-ink-900 mb-3">
            Jobx<span className="text-brand-saffron">Bharat</span>
          </div>
          <p className="text-ink-500 text-sm leading-relaxed mb-6 max-w-xs">
            India's all-in-one work ecosystem — connecting job seekers, recruiters,
            colleges, and the workforce.
          </p>
          <div className="flex gap-3">
            {SOCIALS.map(s => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center
                           text-ink-500 hover:bg-brand-saffron hover:text-white
                           transition-all text-base"
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Link columns */}
        {COLUMNS.map(col => (
          <div key={col.heading}>
            <p className="font-display text-xs font-black uppercase tracking-widest text-ink-300 mb-4">
              {col.heading}
            </p>
            <ul className="space-y-2.5">
              {col.links.map(link => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noopener noreferrer' : undefined}
                    className="font-display text-sm text-ink-500 hover:text-brand-purple transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5
                        flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
          <p className="font-display text-xs text-ink-300">
            © {new Date().getFullYear()} Jobx<span className="text-brand-saffron">Bharat</span> · Made with dreams for <span className="text-brand-saffron">Bharat</span>
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 font-display text-xs text-ink-300">
            <a href="/privacy-policy"           className="hover:text-brand-purple transition-colors">Privacy Policy</a>
            <span className="hidden sm:inline">·</span>
            <a href="/terms-and-conditions"     className="hover:text-brand-purple transition-colors">Terms & Conditions</a>
            <span className="hidden sm:inline">·</span>
            <a href="mailto:supportus@jobxbharat.com" className="hover:text-brand-purple transition-colors">supportus@jobxbharat.com</a>
          </div>
        </div>
      </div>

    </footer>
  );
}
